<template>
    <div class="m-promotionSlider">
        <div class="m-promotionSlider__wrapper">
            <button
                class="btn btn-outline-custom btn-slider slider-prev m-promotionSlider__btn"
                data-slider-prev
                aria-controls="tns1"
                tabindex="-1"
                data-controls="prev"
                @click="prevSlide"
                :disabled="activeSlideIndex === 0"
            >
                <a-icon icon="ArrowLeft" />
            </button>
            <button
                class="btn btn-outline-custom btn-slider slider-next m-promotionSlider__btn"
                data-slider-next
                aria-controls="tns1"
                tabindex="-1"
                data-controls="next"
                @click="nextSlide"
                :disabled="activeSlideIndex + items >= slideCount"
            >
                <a-icon icon="ArrowRight" />
            </button>

            <tiny-slider
                class="m-promotionSlider__slider"
                :ref="'promotionSlider'"
                v-bind="tinySliderOptions"
                @indexChanged="slideChanged"
            >
                <a
                    download
                    :href="slide.urls.original"
                    class="m-promotionSlider__slide promo-details-slide"
                    v-for="slide in data"
                    :key="slide.id"
                    style="overflow: hidden"
                    @click.prevent="
                        clickFile(slide.urls.original, slide.name, $event)
                    "
                    :class="{
                        '--hover':
                            slide.urls.original.includes('pdf') ||
                            imgFormats.some((v) =>
                                slide.urls.original.includes(v)
                            ),
                    }"
                    @mouseenter="hoverFile(true, $event)"
                    @mouseleave="hoverFile(false, $event)"
                >
                    <figure class="m-promotionSlider__figure embed-responsive">
                        <div class="m-promotionSlider__iconWrapper">
                            <template
                                v-if="slide.urls.original.includes('pdf')"
                            >
                                <vue-pdf
                                    style="
                                        width: auto;
                                        height: auto;
                                        max-width: 95%;
                                        max-height: 100%;
                                    "
                                    :src="slide.urls.original"
                                />
                            </template>
                            <template
                                v-else-if="
                                    imgFormats.some((v) =>
                                        slide.urls.original.includes(v)
                                    )
                                "
                            >
                                <img
                                    :src="slide.urls.original"
                                    class="img-fluid"
                                />
                            </template>
                            <template v-else>
                                <a-icon
                                    width="64px"
                                    height="64px"
                                    :icon="iconType(slide.urls.original)"
                                />
                            </template>
                        </div>
                    </figure>
                    <p class="text-primary text-sm">{{ slide.name }}</p>
                </a>
            </tiny-slider>
        </div>
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'
import VuePdf from 'vue-pdf'

export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            tinySliderOptions: {
                items: 3,
                slideBy: 1,
                autoplay: false,
                mouseDrag: true,
                gutter: 10,
                edgePadding: 0,
                autoplayButtonOutput: false,
                controls: false,
                nav: false,
                loop: false,
                responsive: {
                    320: {
                        items: 2
                    },
                    520: {
                        items: 3
                    },
                    768: {
                        items: 3
                    },
                    992: {
                        items: 2
                    }
                }
            },
            activeSlideIndex: 0,
            slideCount: 0,
            items: 0,
            imgFormats: ['jpg', 'png', 'jpeg']
        }
    },
    components: {
        TinySlider: VueTinySlider,
        VuePdf
    },
    methods: {
        prevSlide() {
            this.$refs.promotionSlider.slider.goTo('prev')
        },
        nextSlide() {
            this.$refs.promotionSlider.slider.goTo('next')
        },
        iconType(str) {
            const XlsTypes = ['xls', 'xlsx']
            const DocTypes = ['doc', 'docx']
            if (XlsTypes.some(v => str.includes(v))) {
                return 'Xls'
            } else if (DocTypes.some(v => str.includes(v))) {
                return 'Doc'
            } else {
                return 'Download'
            }
        },
        slideChanged() {
            this.updateSliderInfo()
        },
        async downloadFile(src, fileName) {
            const file = await fetch(src)
            const fileBlob = await file.blob()
            const fileURL = URL.createObjectURL(fileBlob)

            const link = document.createElement('a')
            link.href = fileURL
            link.download = fileName
            link.classList.add('temp-slide-download')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        updateSliderInfo() {
            const sliderInfo = this.$refs.promotionSlider.slider.getInfo()
            this.slideCount = sliderInfo.slideCount
            this.activeSlideIndex = sliderInfo.index
            this.items = sliderInfo.items
        },
        hoverFile(hover, elem) {
            elem.stopPropagation()
            elem.preventDefault()
            const slideElem = elem.target.closest('.m-promotionSlider__slide')
            if (this.deviceType === 'desktop') {
                if (hover) {
                    slideElem.classList.add('--active')
                } else {
                    slideElem.classList.remove('--active')
                }
            }
        },
        clickFile(src, fileName, elem) {
            elem.stopPropagation()
            elem.preventDefault()
            const slideElem = elem.target.closest('.m-promotionSlider__slide')
            const isPdf = slideElem.classList.contains('--hover')
            if (
                this.deviceType === 'desktop' &&
                slideElem.classList.contains('--active')
            ) {
                this.downloadFile(src, fileName)
            }

            if (this.deviceType === 'mobile') {
                document
                    .querySelectorAll('.m-promotionSlider__slide.--active')
                    .forEach(el => {
                        if (el !== slideElem) {
                            el.classList.remove('--active')
                        }
                    })
                if (isPdf) {
                    if (slideElem.classList.contains('--active')) {
                        slideElem.classList.add('--active')
                        this.downloadFile(src, fileName)
                    } else {
                        slideElem.classList.add('--active')
                    }
                } else {
                    this.downloadFile(src, fileName)
                }
            }
        }
    },
    computed: {
        deviceType() {
            return this.$store.getters.getUserDeviceType
        }
    },
    mounted() {
        this.updateSliderInfo()
        document.addEventListener('click', elem => {
            document
                .querySelectorAll('.m-promotionSlider__slide.--active')
                .forEach(el => {
                    if (
                        !elem.target.classList.contains('temp-slide-download')
                    ) {
                        el.classList.remove('--active')
                    }
                })
        })
    }
}
</script>

<style lang="scss">
@import 'tiny-slider/src/tiny-slider';

.m-promotionSlider {
    $sliderHeight: 110px;
    position: relative;
    height: $sliderHeight;

    &__wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    &__slider {
        overflow: hidden;
    }

    &__slide {
        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

        &.--hover.--active {
            transition: 0.3s;
            &:hover {
                height: 200px;
                max-height: 200px;
            }
            .m-promotionSlider__figure {
                min-height: $sliderHeight;
                height: 200px;
                max-height: 200px;
            }
        }
    }
    &__figure {
        height: 110px;
        margin-bottom: 0;
        transition: 0.3s;
    }

    &__iconWrapper {
        min-height: 110px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid;
        background-color: var(--color-white);
        border-radius: var(--border-radius);
        color: var(--color-secondary);

        > span {
            overflow: hidden;
            max-height: 100%;
            border-radius: var(--border-radius);
        }

        > img {
            border-radius: calc(var(--border-radius) - 1px);
        }
    }

    .tns-inner {
        overflow: hidden;
        transform: translateX(5px);
    }

    .tns-outer {
        margin-left: 2.25rem;
        margin-right: calc(2.25rem - 0px);
    }
}
</style>